module.exports = __webpack_public_path__ + "static/forecast/windstock/light-de12763ac44894502c7f89e2b3659ea0.svg";